import { alertCtk, fillCountries } from './utils';
import { ajaxSubmit } from './ajaxindex';
import { validateProfilePart } from './validate';

const jQuery = window.jQuery;

function setValue(name, value) {
  jQuery('#form' + name).val(value);
}

export function validate() {
  validateProfilePart('all', false);
}
export function validateSilent() {
  validateProfilePart('all', true);
}

export function fillValuesJson(json) {
  jQuery('input[name=length][value=' + json.lengthcode + ']').prop(
    'checked',
    true,
  );
  setValue('company', json.company);
  setValue('name', json.name);
  setValue('surname', json.surname);
  setValue('email', json.email);
  setValue('phone', json.phone);
  setValue('street', json.street);
  setValue('city', json.city);
  setValue('psc', json.psc);
  setValue('country', json.country);
  setValue('ic', json.ic);
  setValue('dic', json.dic);
  setValue('passwd', json.passwd);
  setValue('passwd2', json.passwd2);
  validate();
}

function sendOrder(event) {
  console.log('submitting form');
  const f = jQuery('#formsubmit');
  validate();
  if (f.hasClass('notusable')) {
    alertCtk(window.ctkerrormessage);
  } else {
    ajaxSubmit();
  }
  event.preventDefault();
  return false;
}

export function bindHandlers() {
  fillCountries();
  const vals = [
    'company',
    'name',
    'surname',
    'email',
    'phone',
    'street',
    'city',
    'psc',
    'country',
    'ic',
    'dic',
    'passwd',
    'passwd2',
  ];

  vals.forEach((it) => {
    jQuery('#form' + it).on('change paste keyup', validate);
  });
  ['register'].forEach((it) => {
    jQuery('#form' + it).on('change paste keyup', validate);
  });
  ['souhlas'].forEach((it) => {
    jQuery('#form' + it).on('change paste keyup', validate);
  });
  jQuery('input[name=length]').on('change', validate);

  jQuery('#formsubmit').on('click', sendOrder);
  jQuery('#filljs').on('click', () => {
    fillValuesJson({
      lengthcode: '6months',
      company: 'soukroma osoba',
      name: 'Petr',
      surname: 'Obornik',
      email: 'obornik@ctk.cz',
      phone: '6066666666',
      street: 'Opletalova 5',
      city: 'Praha',
      psc: '11100',
      country: 'Česká republika',
      ic: '123456789',
      dic: '43211234',
      passwd: '1',
      passwd2: '1',
    });
  });
  jQuery('#goprofile').on('click', (event) => {
    window.location.assign('https://www.ctk.cz/mojectk/akaprofile.php');
    event.preventDefault();
    return false;
  });

  jQuery(document).on('click', function (e) {
    if (jQuery(e.target).closest('#login-form').length === 0) {
      jQuery('#login-form').removeClass('visible');
    }
  });

  validateSilent();

  jQuery('#sample-img-mail').on('click', function () {
    jQuery('#samples').removeClass('u-hide');
  });

  jQuery('#samples-close').on('click', function (e) {
    jQuery('#samples').addClass('u-hide');
  });
}
